import { render, staticRenderFns } from "./RecommendLeader.vue?vue&type=template&id=0ce15ee5&scoped=true&"
import script from "./RecommendLeader.vue?vue&type=script&lang=js&"
export * from "./RecommendLeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce15ee5",
  null
  
)

export default component.exports